module.exports = __webpack_public_path__ + "static/media/posLogo.69164af2.svg";